
import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  UncontrolledTooltip,
} from "reactstrap";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Select from "react-select"
import Dropzone from "react-dropzone";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCitiesByCountry, getCountries } from "../../../store/address/actions";
import { addNewVendor, updateVendor } from "../../../store/vendor/actions"
import { getVendor_cats } from "../../../store/vendor_cat/actions"
import imageBaseUrl from "../../../helpers/imageBaseUrl";
import { getCeremonies } from "../../../store/ceremony/actions";
import {
  addNewVendor_media,
  updateVendor_media
} from "../../../store/vendor_media/actions"
import moment from "moment";


const AddMediaVendor = (props) => {
  const location = useLocation()
  const history = useHistory()
  const params = useParams()
  const [selectedFiles_1, setselectedFiles_1] = useState(
    location?.state?.image != null
      ? [{ preview: imageBaseUrl + location.state.image }]
      : []
  )
   const [ceremony, setCeremony] = useState(
     location?.state
       ? {
           label: location?.state?.ceremony_name_en,
           value: location?.state?.ceremony_id,
         }
       : null
   )

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch(getCeremonies({is_active:1}))
    dispatch(getCountries())
}, [dispatch])
  
function handleAcceptedFiles_1(files) {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  )
  setselectedFiles_1(files)
}

/**
 * Formats the size
 */
  
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: location?.state?.title || "",
      date: moment(location?.state?.date).format("yyyy-MM-DD"),
    },

    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      date: Yup.string().required("Date is required"),
    }),
    onSubmit: values => {
      let data = {
        title: values.title,
        vendor_date: values.date,
        image: selectedFiles_1[0],
        ceremony_type_id: ceremony.value,
      }

      if (location.state && location.state.id) {
        data.id = location.state.id
        data.vendor_id = location.state.vendor_id
        dispatch(updateVendor_media(data, history))
      } else {
        data.vendor_id = params.vendor_id
        dispatch(addNewVendor_media(data, history))
      }
    },
  })

  const ceremonies = useSelector(
    state => state.ceremony.ceremonies.ceremonies
  )
  
  const ceremoniesOptions = ceremonies?.map(v => {
    return { label: v.name_en, value: v.id }
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="vendors / add media vendors" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h3>{location.state?.vendor_name}</h3>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>

                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    className="custom-validation"
                  >
                    <div className="mb-3">
                      <Label className="form-label">
                        Title<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="title"
                        placeholder="Title"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title || ""}
                        invalid={
                          validation.touched.title && validation.errors.title
                            ? true
                            : false
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">
                          {validation.errors.title}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="example-datetime-local-input"
                        className="col-md-2 col-form-label"
                      >
                        Event date
                      </label>
                      <div className="col-md-2">
                        <input
                          name='date'
                        
                          className="form-control"
                          type="date"
                          defaultValue="2019-08-19T13:45:00"
                          id="example-datetime-local-input"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={moment(validation.values.date).format('yyyy-MM-DD') }
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <Label>Ceremony</Label>
                      <Select
                        value={ceremony}
                        onChange={option => {
                          setCeremony(option)
                        }}
                        options={ceremoniesOptions}
                        classNamePrefix="select2-selection"
                      />
                    </div>

                    <Label>Image</Label>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles_1(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted uil uil-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles_1.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div
                              className="p-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                              <div
                                className="align-self-center"
                                onClick={() => {
                                  setselectedFiles_1([])
                                  // setVendor(prev => ({ ...prev, removeImage: 1 }))
                                }}
                              >
                                <i
                                  className="uil uil-trash-alt font-size-24 text-danger"
                                  id="deletetooltip"
                                />
                                <UncontrolledTooltip
                                  placement="top"
                                  target="deletetooltip"
                                >
                                  Delete
                                </UncontrolledTooltip>
                              </div>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      <Button type="submit" color="primary" className="">
                        Submit
                      </Button>{" "}
                      <Button type="reset" color="secondary" className="">
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default AddMediaVendor
